import { Box, Card, CardOverflow, styled } from '@mui/joy';

import { theme } from 'theme';

export const iconStyle = {
  fill: theme.palette.success[400],
  fontSize: 32,
};

export const dateStyle = {
  color: theme.palette.neutral[400],
};

export const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

export const CardWrapper = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.body,
  border: `1px dashed ${theme.palette.primary[300]}`,
  width: '50%',
  minWidth: '200px',
}));

export const RightCardOverflow = styled(CardOverflow)({
  alignItems: 'center',
});

export const RightWrapper = styled(Box)({
  padding: '0 16px 0 8px',
});
